import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';

import { useDocumentViewerModalStyles } from './styles/documentViewerModalStyles';

interface DocumentViewerModalProps {
  open: boolean;
  accept: () => void;
  decline: () => void;
  content: string;
  title: string;
}

const DocumentViewerModal: React.FC<DocumentViewerModalProps> = ({
  open,
  accept,
  decline,
  content,
  title,
}) => {
  const theme = useTheme();
  const styles = useDocumentViewerModalStyles(theme);

  return (
    <Dialog
      open={open}
      onClose={decline}
      maxWidth="lg"
      fullWidth
      data-testid="document-viewer-dialog"
      slotProps={{
        paper: { sx: styles.dialogPaper },
      }}
    >
      <DialogTitle sx={styles.dialogTitle} data-testid="document-viewer-title">
        <Typography variant="overline" sx={styles.dialogTitleEyebrow}>
          Legal & Compliance
        </Typography>
        <Typography component="h2" sx={styles.dialogTitleText}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent sx={styles.dialogContent} data-testid="document-viewer-content">
        <Box sx={styles.dialogScrollArea} data-testid="document-viewer-content-box">
          <Typography sx={styles.dialogBodyText} data-testid="document-viewer-text">
            {content}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={styles.dialogActions} data-testid="document-viewer-actions">
        <Button
          variant="contained"
          onClick={accept}
          data-testid="document-viewer-accept-button"
          sx={styles.acceptButton}
        >
          Accept
        </Button>
        <Button
          variant="outlined"
          onClick={decline}
          data-testid="document-viewer-decline-button"
          sx={styles.declineButton}
        >
          Decline
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentViewerModal;
